import React from "react";
import ProductPage from "./ProductPage";
import image from "../Images/product-heroes/project-hero.png";
import detailImage from "../Images/dashboards/hr-dashboard.png";

const product = {
  "id": "projects",
  "title": "Project Management",
  "headline": "Plan with clarity.",
  "accent": "Deliver as a team.",
  "description": "Bring project plans, milestones, team collaboration and budget tracking together. Keep everyone aligned from the first assignment to the final delivery.",
  "checks": [
    "Project milestones",
    "Shared team updates",
    "Budget visibility"
  ],
  "badge": "Your projects, connected",
  "imageAlt": "Illustration of colleagues planning project milestones and reviewing progress",
  "summary": [
    {
      "icon": "calendar",
      "title": "Clear project plans",
      "text": "Connect goals, milestones and deadlines."
    },
    {
      "icon": "people",
      "title": "Team collaboration",
      "text": "Keep project files and conversations together."
    },
    {
      "icon": "wallet",
      "title": "Budget visibility",
      "text": "Review expenses alongside project progress."
    }
  ],
  "featuresTitle": "Keep every part of your project in view",
  "featuresSubtitle": "Connect the people, plans and resources that move your projects forward.",
  "features": [
    {
      "title": "Planning & scheduling",
      "icon": "calendar",
      "text": "Turn project goals into a plan your team can follow.",
      "points": [
        "Project milestones and deadlines",
        "Gantt charts and timelines",
        "Clear project roadmaps"
      ]
    },
    {
      "title": "Collaboration & files",
      "icon": "people",
      "text": "Bring project conversations and documents into one place.",
      "points": [
        "Team collaboration tools",
        "Files attached to project tasks",
        "Shared project information"
      ]
    },
    {
      "title": "Tasks & resource allocation",
      "icon": "layers",
      "text": "Organize work around team availability and workload.",
      "points": [
        "Task assignment automation",
        "Resource and workload management",
        "Real-time progress tracking"
      ]
    },
    {
      "title": "Budgets & expenses",
      "icon": "wallet",
      "text": "Keep costs visible throughout the project.",
      "points": [
        "Project expense tracking",
        "Budget monitoring",
        "Client billing and invoicing"
      ]
    },
    {
      "title": "Performance reports",
      "icon": "chart",
      "text": "Understand how your projects are progressing.",
      "points": [
        "Customizable project reports",
        "Project KPI tracking",
        "Efficiency and cost insights"
      ]
    },
    {
      "title": "Delivery coordination",
      "icon": "file",
      "text": "Connect milestones with the work needed to reach them.",
      "points": [
        "Shared goals and task ownership",
        "Team progress visibility",
        "Project document organization"
      ]
    }
  ],
  "detailImageAlt": "BillPunch HR dashboard with team information, employee distribution and workforce activity",
  "detailLabel": "Built for Team Delivery",
  "detailTitle": "One plan. A team moving together.",
  "detailText": "Bring task assignments, team availability and project information into a shared workflow. Review progress and spending without losing sight of the people doing the work.",
  "detailPoints": [
    "Coordinate tasks and project milestones",
    "Keep project documents within reach",
    "Review performance and budget trends"
  ],
  "workflowTitle": "A connected path from planning to delivery",
  "steps": [
    [
      "Define the project",
      "Set goals, milestones and expected delivery dates."
    ],
    [
      "Organize your team",
      "Assign tasks based on availability and workload."
    ],
    [
      "Track work and costs",
      "Review progress, documents and project expenses."
    ],
    [
      "Review the outcome",
      "Use reports to understand delivery and performance."
    ]
  ],
  "cta": "Bring your next project into focus."
};
product.image = image;
product.detailImage = detailImage;

const Projectmanagement = () => <ProductPage product={product} />;
export default Projectmanagement;
